import React from 'react'
import Grid from '@material-ui/core/Grid'
import { DatePicker } from '@material-ui/pickers'
import IconButton from '@material-ui/core/IconButton'
import CalendarIcon from '@material-ui/icons/CalendarTodayOutlined'
import CancelIcon from '@material-ui/icons/Cancel'

import moment, { Moment } from 'config/moment'
import { STRINGS } from 'consts'

const defaultInputProps = (value: Moment | null, setValue: (date: Moment | null) => void) => ({
  style: {
    fontFamily: 'Montserrat',
    fontWeight: 400,
    fontSize: 14,
    paddingLeft: 10,
  },
  endAdornment: value ? (
    <IconButton
      onClick={e => {
        e.stopPropagation()
        setValue(null)
      }}
    >
      <CancelIcon style={{ width: 15, height: 15, color: '#6B7280' }} />
    </IconButton>
  ) : (
    <IconButton>
      <CalendarIcon style={{ width: 15, height: 15, color: '#6B7280' }} />
    </IconButton>
  ),
})

interface DateRangeFilterProps {
  startDate: Moment | null
  setStartDate: (date: Moment | null) => void
  endDate: Moment | null
  setEndDate: (date: Moment | null) => void
  disabled?: boolean
}

const DateRangeFilter: React.FC<DateRangeFilterProps> = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  disabled = false,
}) => {
  const handleStartDateChange = (newDate: Moment | null) => {
    if (newDate) {
      setStartDate(newDate.startOf('day'))

      if (endDate && newDate.isSameOrAfter(endDate)) {
        setEndDate(
          newDate
            .clone()
            .add(1, 'day')
            .endOf('day'),
        )
      }
    }
  }

  const handleEndDateChange = (newDate: Moment | null) => {
    if (newDate) {
      setEndDate(newDate.endOf('day'))
    }
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <DatePicker
          required={startDate !== null || endDate !== null}
          value={startDate}
          defaultValue={null}
          onChange={handleStartDateChange}
          autoOk
          orientation="landscape"
          format={STRINGS.DATE_FORMAT}
          initialFocusedDate={moment()}
          style={{ width: '100%' }}
          label="Desde"
          maxDate={moment().endOf('day')}
          maxDateMessage="La fecha no debe ser posterior a la fecha máxima"
          InputLabelProps={defaultInputProps(startDate, setStartDate)}
          InputProps={{
            ...defaultInputProps(startDate, setStartDate),
          }}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={6}>
        <DatePicker
          required={startDate !== null || endDate !== null}
          value={endDate}
          defaultValue={null}
          onChange={handleEndDateChange}
          autoOk
          orientation="landscape"
          format={STRINGS.DATE_FORMAT}
          initialFocusedDate={startDate || moment()}
          style={{ width: '100%' }}
          label="Hasta"
          minDate={startDate || undefined} // Restringir fechas anteriores a "Desde"
          maxDate={moment().endOf('day')}
          minDateMessage="La fecha no debe ser anterior a la fecha inicial"
          maxDateMessage="La fecha no debe ser posterior a la fecha máxima"
          InputLabelProps={defaultInputProps(endDate, setEndDate)}
          InputProps={{
            ...defaultInputProps(endDate, setEndDate),
          }}
          disabled={disabled}
        />
      </Grid>
    </Grid>
  )
}

DateRangeFilter.defaultProps = {
  disabled: false,
}

export default DateRangeFilter
